import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { UserService } from './user/user.service';
import { HttpRequestService } from './http-request.service';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { iEntityFilterParams } from '@coreinterfaces/entity-params';
import { iUser } from '@coreinterfaces/user';

@Injectable()
export class AuthService {

  constructor(private _userService: UserService,
              private _httpClient: HttpClient,
              private _httpService: HttpRequestService) {}
  /**
   * Custom post request
   * @param reqURL
   * @param bodyString
   * @param requestOptions
   * @returns {any | any[] | number}
   */

  post(endPoint: string, requestParams: any): Observable<any> {
    const bodyString = JSON.stringify(requestParams);
    return this._httpService.authApiNewPost(endPoint, bodyString);
  }

  /*****************************************************  GETTERS  ****************************************************/


  /*****************************************************  ACTIONS  ****************************************************/

    tokenValidate(token: string): Observable<any> {
      const reqUrl = 'access_token/validate';
      let requestParams: iEntityFilterParams = { access_token: token };
      return this.post(reqUrl, requestParams);
    }

    tokenRefresh(refresh_token = this._userService.refreshToken): Observable<any> {
      const reqUrl = 'refresh';
      let requestParams: iEntityFilterParams = { refresh_token: refresh_token };
      return this.post(reqUrl, requestParams);
    }

    login(loginData: iUser): Observable<any> {
      const reqUrl = 'login';
      return this.post(reqUrl, loginData);
    }

    loginAsCC(portalId: number, requestOptions?: any): Observable<any> {
      const reqUrl = 'admin/content_creator/login';
      let requestParams: any = { portal_id: portalId, token: this._userService.token };
      return this.post(reqUrl, requestParams);
    }

    logout(): Observable<any> {
      const reqUrl = 'logout';
      let requestParams: iEntityFilterParams = { refresh_token: this._userService.refreshToken };
      return this.post(reqUrl, requestParams);
    }

}
